// extracted by mini-css-extract-plugin
export default {"Section":"Section_Section__8Buna","NoPadding":"Section_NoPadding__-GcsK","TitleSection":"Section_TitleSection__t6KMQ"};